<template>
  <div class="dropdown">
    <button
      class="btn btn-light float-end"
      type="button"
      id="dropdownMenu2"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      @keydown.enter="focusFirstItem"
    >
      <span class="visually-hidden">{{ getAriaPurpose() }}</span>
      <i class="bi bi-three-dots-vertical"></i>
    </button>
    <ul ref="commandList" class="dropdown-menu" aria-labelledby="dropdownMenu2">
      <li v-if="permissions?.canView">
        <button
          ref="commands"
          class="dropdown-item"
          type="button"
          tabindex="0"
          @click="$emit('viewClicked', id)"
        >
          View
        </button>
      </li>
      <li v-if="permissions?.canEdit">
        <button
          ref="commands"
          class="dropdown-item"
          type="button"
          tabindex="0"
          @click="$emit('editClicked', id)"
        >
          Edit
        </button>
      </li>
      <li v-if="permissions?.canDelete">
        <button
          ref="commands"
          class="dropdown-item"
          type="button"
          tabindex="0"
          @click="$emit('deleteClicked', id)"
        >
          Delete
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, nextTick } from "vue";
import { Dropdown } from "bootstrap";
import PermissionSet from "@/guiide/ts/permissionSet";

const props = defineProps({
  id: { type: Number, required: true },
  permissions: { type: Object as () => PermissionSet, required: true },
  ariaPurpose: { type: String, default: "" }
});

defineEmits(["viewClicked", "editClicked", "deleteClicked"]);

const commandList = ref<HTMLElement|null>(null);
const commands = ref<HTMLElement[]>([]);

onMounted(() => {
  const dropdownElement = document.getElementById("dropdownMenu2");
  if (dropdownElement) {
    new Dropdown(dropdownElement);
  }
});

function getAriaPurpose(): string {
  return props.ariaPurpose
    ? `Options for ${props.ariaPurpose}`
    : "Options";
}

const focusFirstItem = async () => {
  await nextTick();
  const items = commandList.value?.querySelectorAll('button.dropdown-item');
  if (items?.length) {
    (items[0] as HTMLElement).focus();
    commands.value = Array.from(items) as HTMLElement[];
  }
};
</script>

<style scoped>
@media (max-width: 767px) {
  .dropdown-menu {
    position: static !important;
  }
}

.btn-light {
    background-color: transparent !important;
}
</style>
